import { render, staticRenderFns } from "./equity.vue?vue&type=template&id=fa61c28c&scoped=true&"
import script from "./equity.vue?vue&type=script&lang=js&"
export * from "./equity.vue?vue&type=script&lang=js&"
import style0 from "./equity.vue?vue&type=style&index=0&id=fa61c28c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa61c28c",
  null
  
)

export default component.exports